import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Company } from 'app/models/company.model';
import { Menu } from 'app/models/menu.model';
import { RoleEnum } from 'app/models/role.model';
import { CompanyService } from 'app/services/company.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { ro } from 'date-fns/locale';
import { cloneDeep } from 'lodash';
import { BaseFormComponent } from '../../../base-form.component';

export class RoleModel {
    public id?: string
    public name?: string
}

@Component({
    selector: 'role-menu-form',
    templateUrl: './role-menu-form.component.html',
    styleUrls: ['./role-menu-form.component.scss']
})
export class RoleMenuFormComponent extends BaseFormComponent implements OnInit {

    public role: RoleModel
    public rols;
    public selectedCompany: Company;
    private _roleMenues: Array<RoleMenu> = [];
    public adminForMenus: Array<Menu> = [];
    public personelForMenus: Array<Menu> = [];
    public driverForMenus: Array<Menu> = [];

    private _allMenuItems: Array<Menu> = [];


    private _adminMenus: Array<Menu> = [];

    public get adminMenus(): Array<Menu> {
        return this._adminMenus;
    }
    private _driverMenus: Array<Menu> = [];

    public get driverMenus(): Array<Menu> {
        return this._driverMenus;
    }
    private _personelMenus: Array<Menu> = [];

    public get personelMenus(): Array<Menu> {
        return this._personelMenus;
    }

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
        private toasterService: ToasterService,
    ) {
        super();
    }


    public async ngOnInit() {
        this._allMenuItems = await this.getMenus();
        this._adminMenus = cloneDeep(this._allMenuItems);
        this._personelMenus = cloneDeep(this._allMenuItems);
        this._driverMenus = cloneDeep(this._allMenuItems);
        this.adminMenusLoad();
        this.driverMenusLoad();
        this.personelMenusLoad();
    }

    public async adminMenusLoad() {

        try {
            this.rols = await this.getRols(RoleEnum.Admin);
        } catch (error) {
            console.warn(error);
        }

        this._adminMenus.forEach(x => {
            this.rols.forEach(y => {
                if (x.id == y.menuId && x.id != 1) {
                    x.checked = true;
                }
            })
        })

        if (this.role.id != "-1") {
            this._adminMenus = this._adminMenus.filter(x => x.id != 17)
        }

        for (let index = 0; index < this.adminMenus.length; index++) {
            const element = this._adminMenus[index];
            let subMenus = this._adminMenus.filter(x => x.parentId == element.id)
            element.children = subMenus;
        }
        this.adminForMenus = this._adminMenus.filter(x => x.parentId == 1);
    }

    public async driverMenusLoad() {

        try {
            this.rols = await this.getRols(RoleEnum.Driver);
        } catch (error) {
            console.warn(error);
        }

        this._driverMenus.forEach(x => {
            this.rols.forEach(y => {
                if (x.id == y.menuId && x.id != 1) {
                    x.checked = true;
                }
            })
        })

        if (this.role.id != "-1") {
            this._driverMenus = this._driverMenus.filter(x => x.id != 17)
        }

        for (let index = 0; index < this.driverMenus.length; index++) {
            const element = this._driverMenus[index];
            let subMenus = this._driverMenus.filter(x => x.parentId == element.id)
            element.children = subMenus;
        }
        this.driverForMenus = this._driverMenus.filter(x => x.parentId == 1);
    }

    public async personelMenusLoad() {

        try {
            this.rols = await this.getRols(RoleEnum.Personel);
        } catch (error) {
            console.warn(error);
        }

        this._personelMenus.forEach(x => {
            this.rols.forEach(y => {
                if (x.id == y.menuId && x.id != 1) {
                    x.checked = true;
                }
            })
        })

        if (this.role.id != "-1") {
            this._personelMenus = this._personelMenus.filter(x => x.id != 17)
        }

        for (let index = 0; index < this.personelMenus.length; index++) {
            const element = this._personelMenus[index];
            let subMenus = this._personelMenus.filter(x => x.parentId == element.id)
            element.children = subMenus;
        }
        this.personelForMenus = this._personelMenus.filter(x => x.parentId == 1);
    }

    public adminRoleCheck() {
        this._adminMenus.forEach(x => {
            this.rols.forEach(y => {
                if (x.id == y.menuId && x.id != 1) {
                    x.checked = true;
                }
                else {
                    x.checked = false;
                }
            })
        })
    }

    public personelRoleCheck() {
        this._personelMenus.forEach(x => {
            this.rols.forEach(y => {
                if (x.id == y.menuId && x.id != 1) {
                    x.checked = true;
                }
                else {
                    x.checked = false;
                }
            })
        })
    }

    public driverRoleCheck() {
        this._driverMenus.forEach(x => {
            this.rols.forEach(y => {
                if (x.id == y.menuId && x.id != 1) {
                    x.checked = true;
                }
                else {
                    x.checked = false;
                }
            })
        })
    }

    public setAdminRoleMenus() {
        var filterMenues = this._adminMenus.filter(
            element => element.checked == true
        )
        filterMenues.forEach(g => {
            var roleMenu = new RoleMenu()
            roleMenu.role = RoleEnum.Admin
            roleMenu.menuId = g.id
            roleMenu.companyId = this.selectedCompany.id;

            var parent = this._roleMenues.filter(x => x.menuId == g.parentId && x.role == RoleEnum.Admin);
            if (parent.length == 0) {
                var role = new RoleMenu();
                role.role = RoleEnum.Admin
                role.menuId = g.parentId;
                role.companyId = this.selectedCompany.id;
                this._roleMenues.push(role)
            }

            var tempRole = this._roleMenues.findIndex(x => x.companyId===roleMenu.companyId && x.menuId===roleMenu.menuId && x.role===roleMenu.role )
            if (tempRole > -1) {
                return
            }
            this._roleMenues.push(roleMenu)
        })
    }

    public setPersonelRoleMenus() {
        var filterMenues = this._personelMenus.filter(
            element => element.checked == true
        )
        filterMenues.forEach(g => {
            var roleMenu = new RoleMenu()
            roleMenu.role = RoleEnum.Personel
            roleMenu.menuId = g.id
            roleMenu.companyId = this.selectedCompany.id;

            var parent = this._roleMenues.filter(x => x.menuId == g.parentId && x.role == RoleEnum.Personel);
            if (parent.length == 0) {
                var role = new RoleMenu();
                role.role = RoleEnum.Personel;
                role.menuId = g.parentId;
                role.companyId = this.selectedCompany.id;
                this._roleMenues.push(role)
            }
            this._roleMenues.push(roleMenu)
        })
    }

    public setDriverRoleMenus() {
        var filterMenues = this._driverMenus.filter(
            element => element.checked == true
        )
        filterMenues.forEach(g => {
            var roleMenu = new RoleMenu()
            roleMenu.role = RoleEnum.Driver
            roleMenu.menuId = g.id
            roleMenu.companyId = this.selectedCompany.id;

            var parent = this._roleMenues.filter(x => x.menuId == g.parentId && x.role == RoleEnum.Driver);
            if (parent.length == 0) {
                var role = new RoleMenu();
                role.role = RoleEnum.Driver;
                role.menuId = g.parentId;
                role.companyId = this.selectedCompany.id;
                this._roleMenues.push(role)
            }
            this._roleMenues.push(roleMenu)
        })
    }

    public async save() {
        this._roleMenues = []
        this.setAdminRoleMenus();
        this.setDriverRoleMenus();
        this.setPersonelRoleMenus();
        try {
            await this.addMenus();
            this.toasterService.toastSuccess();
            this.added.emit(true);

        } catch (error) {
            console.warn(error);
            this.toasterService.toastFail();
            this.added.emit(false);

        }
    }


    async getMenus(): Promise<Array<Menu>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "menus")
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    async getRols(rols): Promise<Array<Menu>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "menus/rolemenus/" + rols + '?companyId=' + this.selectedCompany.id)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    async addMenus(): Promise<Array<RoleModel>> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "menus/add/" + this.selectedCompany.id, this._roleMenues)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    public selectMenu(menuItem: Menu) {

        if (menuItem.checked) {
            menuItem.children.forEach(element => {
                element.checked = true;
            });
        }
        else {
            menuItem.children.forEach(element => {
                element.checked = false;
            });
        }

    }
    indeterminateMenu(menuItem: Menu) {
        if (menuItem.children == null) {
            return false
        }
        return !menuItem.children.every(c => c.checked == true) && !menuItem.children.every(c => c.checked == false)
        // return menuItem.children.filter(c => c.checked).length > 0 && !menuItem.checked;
    }
    updateAllComplete(menuItem: Menu) {
        menuItem.checked = menuItem.children.every(t => t.checked == true)
    }

    public selectAdminAll() {
        this._adminMenus.forEach((g: any) => {
            g.checked = (g.parentId != null) ? true : false
        })
    }

    public deAdminSelectAll() {
        this._adminMenus.forEach((g: any) => {
            g.checked = false;
        })
    }

    public selectPersonelAll() {
        this._personelMenus.forEach((g: any) => {
            g.checked = (g.parentId != null) ? true : false
        })
    }

    public dePersonelSelectAll() {
        this._personelMenus.forEach((g: any) => {
            g.checked = false;
        })
    }

    public selectDriverAll() {
        this._driverMenus.forEach((g: any) => {
            g.checked = (g.parentId != null) ? true : false
        })
    }

    public deDriverSelectAll() {
        this._driverMenus.forEach((g: any) => {
            g.checked = false;
        })
    }
}
export class RoleMenu {
    public role?: number
    public menuId?: number
    public menu?: Menu
    public companyId?: number
}
